import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { ServiceTypeDto, ServiceUnitTypeDto } from "../../interfaces/serviceDefinition/service-definition";
import { apiGet } from "../../utilities/api-client/apiRequest";


export async function GetAllServiceUnitTypeAsync(
    authToken: string,
): Promise<ApiResponse<ServiceUnitTypeDto[]>> {
    const apiUrl: string = `/ServiceUnitType/GetAllServiceUnitTypes`;

    var res = apiGet<ApiResponse<ServiceUnitTypeDto[]>>(
        apiUrl, authToken)

    return res;
}